import { render, staticRenderFns } from "./form-profileorders.vue?vue&type=template&id=03f9ccee"
import script from "./form-profileorders.vue?vue&type=script&lang=js"
export * from "./form-profileorders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports